const PT = require("prop-types");
const _ = require("lodash");
const React = require("react");
const createReactClass = require("create-react-class");
const Quad = require("./Quad");
const QuadUtil = require("../util/QuadUtil");

const styles = require("./styles/BlueLabel.css");

module.exports = createReactClass({
	displayName: "BlueLabel",

	propTypes: {
		label: PT.oneOfType([PT.string, PT.element]),
		labelImageSrc: PT.string,
		labelStyle: PT.object,
		labelImageClass: PT.string,
		labelClass: PT.string,
		quadStyleNum: PT.number,
		quadStyleCustom: PT.func,
		className: PT.string,
		hasPadding: PT.bool,
		handleClick: PT.func,
		onMouseDown: PT.func,
		isDisabled: PT.bool,
	},

	render: function() {
		const {
			isDisabled,
			handleClick,
			onMouseDown,
			quadStyleNum,
			quadStyleCustom,
			labelClass,
			hasPadding,
			labelImageSrc,
			labelImageClass,
			className,
			labelStyle,
			label,
		} = this.props;
		let quadStyle;
		if (_.isInteger(quadStyleNum)) {
			quadStyle = QuadUtil.getBlueLabelSet(quadStyleNum % 3);
		} else if (quadStyleCustom) {
			quadStyle = quadStyleCustom;
		} else {
			quadStyle = QuadUtil.quadTable.blueLabel;
		}

		let backgroundClass = isDisabled ? styles.disabledBg : styles.bg;
		backgroundClass = labelClass || backgroundClass;
		let quadWrapperClass = styles.quadWrapper;
		quadWrapperClass += hasPadding ? " " + styles.quadPadding : "";

		let quad = <Quad quad={quadStyle} backgroundClass={backgroundClass} />;

		let contentImg;
		if (labelImageSrc) {
			contentImg = (
				<img
					className={styles.image + " " + labelImageClass}
					src={labelImageSrc}
				/>
			);
		}

		let wrapperClass = className;

		if (handleClick) {
			wrapperClass += " " + styles.clickable;
			if (isDisabled) {
				wrapperClass += " " + styles.disabled;
			}

			quad = (
				<Quad
					quad={quadStyle}
					backgroundClass={backgroundClass}
					shadowOffset={3}
					shadowOpacity={0.4}
				/>
			);
		}
		return (
			<div
				className={wrapperClass}
				onClick={isDisabled ? null : handleClick}
				onMouseDown={onMouseDown}
			>
				<div className={quadWrapperClass}>{quad}</div>
				{contentImg}
				<span className={styles.text} style={labelStyle}>
					{label}
				</span>
			</div>
		);
	},
});
